import gql from 'graphql-tag'

export default gql`
  mutation resetBillingCycle($subscriptionId: String!) {
    resetBillingCycle(subscriptionId: $subscriptionId) {
      success
      message
      clientSecret
    }
  }
`
